import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dcd6e7b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "categories lg:mr-8 lg:mt-4 mx-auto lg:mx-0 w-full lg:w-auto" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full text-center my-4" }, [
  /*#__PURE__*/_createElementVNode("b", { class: "text-3xl" }, "Categories")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Category = _resolveComponent("Category")!
  const _component_List = _resolveComponent("List")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_List, {
      items: [{id: -1, name: 'All', count: _ctx.totalCount}, ...(_ctx.getters.categories || [])],
      onAdd: _cache[0] || (_cache[0] = ({name, pos}) => _ctx.add(name, pos)),
      hideTopAdd: !_ctx.getters.isModer,
      addInPos: _ctx.getters.isModer
    }, {
      default: _withCtx(({item}) => [
        _createVNode(_component_Category, {
          category: item,
          onUpdate: ({field, value}) => _ctx.edit(item, field, value),
          onDel: ($event: any) => (_ctx.del(item)),
          onSelect: ($event: any) => (_ctx.select(item))
        }, null, 8, ["category", "onUpdate", "onDel", "onSelect"])
      ]),
      _: 1
    }, 8, ["items", "hideTopAdd", "addInPos"])
  ]))
}